import { memo } from "react";

import noop from "lodash/noop";

import { BasicModal, Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { modalConfig } from "./config";
import { unsavedModalKeys } from "./dataAutomation";
import * as SC from "./styles";
import { CANCEL, CONTINUE, MAIN_TEXT, OVER_THE_LIMIT, TITLE } from "./texts";
import type { CancelModalSchema } from "./types";

export const UnsavedModal = memo(
    ({ isOverTheLimit, isOpen, onClose, onConfirm, targetFunction }: CancelModalSchema) => {
        const onClick = () => {
            onConfirm();
            targetFunction();
        };

        return (
            <BasicModal
                isOpen={isOpen}
                onRequestClose={onClose}
                customStyles={modalConfig}
                closeIconConfig={{
                    show: false,
                    onClick: noop,
                }}
            >
                <SC.Header data-automation={unsavedModalKeys.title}>
                    <SC.Title>{translate(TITLE)}</SC.Title>
                </SC.Header>

                <SC.Text>{isOverTheLimit ? translate(OVER_THE_LIMIT) : translate(MAIN_TEXT)}</SC.Text>

                <SC.ButtonGroup data-automation={unsavedModalKeys.btnContainer}>
                    <Button
                        type="flat"
                        onClick={targetFunction}
                    >
                        {translate(CANCEL)}
                    </Button>

                    {isOverTheLimit ? null : <Button onClick={onClick}>{translate(CONTINUE)}</Button>}
                </SC.ButtonGroup>
            </BasicModal>
        );
    },
);

UnsavedModal.displayName = "CancelModal";
